/** Strip spaces/dashes; drop leading 0; handle +91 / 91 prefix; keep up to 10 national digits. */
export function normalizeIndianMobileDigits(raw) {
  let d = String(raw ?? '').replace(/\D/g, '');
  while (d.startsWith('0')) d = d.slice(1);
  if (d.length >= 12 && d.startsWith('91')) {
    return d.slice(-10);
  }
  if (d.startsWith('91') && (d.length === 10 || d.length === 11)) {
    return d.slice(2, 12);
  }
  return d.slice(0, 10);
}

export function isValidIndianMobile(digits) {
  return /^[6-9]\d{9}$/.test(digits);
}

/** Block obvious test numbers (e.g. 6666666666, 7777777777) and any 10 identical digits. */
export function isBlockedDummyMobile(digits) {
  if (digits.length !== 10) return false;
  if (/^(\d)\1{9}$/.test(digits)) return true;
  return false;
}
